<template>

    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/user' }">基础设置</el-breadcrumb-item>
                    <el-breadcrumb-item>操作日志</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="operateLog" class="demo-form-inline" size="mini">
                    <el-form-item label="操作人">
                        <el-input v-model="operateLog.condition.operatorName" placeholder="操作人"></el-input>
                    </el-form-item>
                    <el-form-item label="操作类型">
                        <el-select v-model="operateLog.condition.operateType" filterable placeholder="请选择" clearable>
                            <el-option
                            v-for="item in operateTypes"
                            :key="item.dictCode"
                            :label="item.dictDesc"
                            :value="item.dictCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建日期">
                        <el-col :span="11">
                        <el-date-picker type="date" placeholder="选择日期" v-model="operateLog.condition.createTimeStart" valueFormat="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-date-picker type="date" placeholder="选择日期" v-model="operateLog.condition.createTimeEnd" valueFormat="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="queryOperateLog">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table
                    :data="operateLogs"
                    size="mini"
                    :height="tableHeight"
                    border
                    v-loading="loading"
                    empty-text="暂无数据"
                    style="width: 100%">
                    <el-table-column fixed prop="operatorName" label="操作人" width="200">
                    </el-table-column>
                    <el-table-column prop="operateType" label="操作类型" width="200">
                    </el-table-column>
                    <el-table-column prop="operateObj" label="操作表对象" width="200">
                    </el-table-column>
                    <el-table-column prop="operateText" show-overflow-tooltip label="操作记录">
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10,20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
        
    </div>
    
</template>

<script>

    export default {
        name:'OperateLog',
        data() {
            return {
                operateLog:{
                    condition:{},
                    pageNum: 1,
                    pageSize:10
                },
                drawer: false,
                direction: 'rtl',
                operateLogs: [],
                currentPage: 1,
                pageSize:20,
                total:10,
                timer:'',
                percentageProp:{},
                title:"新增提成比例",
                dialogFormVisible: false,
                loading: true,
                operateTypes:[],
                tableHeight: "",//表格高度
            }
        },
        methods: {
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryOperateLog();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryOperateLog();
            },
            queryOperateLog() {
                this.loading = true;
                this.operateLog.pageNum = this.currentPage;
                this.operateLog.pageSize = this.pageSize;
                this.$axios.post("/operateLog/find",this.operateLog).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.operateLogs = res.data.result.list;
                            this.total = res.data.result.total;
                        }
                        this.loading = false;
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            queryDicts(dictType) {
                let condition = {value:dictType};
                this.$axios.post("/dictionary/findByDictType",condition).then(
                    res=>{
                        if(res.data.status === "success"){
                            if(dictType === 'OPERATE_TYPE') {
                                this.operateTypes = res.data.result;
                            }
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            getTableHeight() {
                let tableH = 300; //距离页面下方的高度
                this.tableHeight = window.innerHeight - tableH;
            },
        },
        mounted() {
            this.queryOperateLog();
            this.queryDicts('OPERATE_TYPE');
        },
        created() {
            this.getTableHeight();
        }
        
    }


</script>

<style scoped>

   .el-form {
       margin-top: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }
   .line {
        text-align: center;
   }
   .el-button {
        margin-left: 20px;
   }

   .el-select {
        width: 220px;
    }

    .el-input {
        width: 220px;
    }

</style>
